/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card[_ngcontent-%COMP%]{overflow:visible}.multi-select[_ngcontent-%COMP%]{border-radius:4px;display:inline-block;width:100%}\n/*# sourceMappingURL=step.component.css.map*/"];
export { styles as styles };
